<div class="card flex justify-content-center gap-3" [ngClass]="isProjectOwnershipValid? '': 'disabled'" [style.pointer-events]="isProjectOwnershipValid? 'auto': 'none'">
    <app-checkbox class="flex" [name]="'group'" [options]="options" [binary]="false" [model]="selectedOptions" (onSelectionChangedEvent)="onModelOptionsChanged($event)"></app-checkbox>
</div>
